import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.match.js';

class GetAssetPlaybackId {
  execute(assetVideoUrl) {
    const regex = /\/([a-zA-Z0-9]+)\.m3u8$/;
    const matches = assetVideoUrl.match(regex);
    if (matches && matches.length > 1) {
      return matches[1];
    }
    return undefined;
  }
}

export { GetAssetPlaybackId };
